/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Any price adjustments associated with this itinerary.
 * @export
 * @interface Adjustment
 */
export interface Adjustment {
    /**
     * The amount of the adjustment.
     * @type {string}
     * @memberof Adjustment
     */
    value?: string;
    /**
     * The type of the adjustment.
     * @type {string}
     * @memberof Adjustment
     */
    type?: string;
    /**
     * The currency of the adjustment.
     * @type {string}
     * @memberof Adjustment
     */
    currency?: string;
}

/**
 * Check if a given object implements the Adjustment interface.
 */
export function instanceOfAdjustment(value: object): value is Adjustment {
    return true;
}

export function AdjustmentFromJSON(json: any): Adjustment {
    return AdjustmentFromJSONTyped(json, false);
}

export function AdjustmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Adjustment {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'type': json['type'] == null ? undefined : json['type'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function AdjustmentToJSON(json: any): Adjustment {
    return AdjustmentToJSONTyped(json, false);
}

export function AdjustmentToJSONTyped(value?: Adjustment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'type': value['type'],
        'currency': value['currency'],
    };
}

